import { toasts as EnUsToasts } from '../en-us/toasts';
import { AgResourceLanguage } from '../types';

export const toasts: AgResourceLanguage['toasts'] = {
  ...EnUsToasts,
  useChangeShippingMethod: {
    ...EnUsToasts.useChangeShippingMethod,
    nextOrderMethodChanged: 'Méthode d’expédition pour la prochaine commande modifiée avec succès',
    subscriptionMethodChanged: 'Méthode d’expédition pour l’abonnement modifiée avec succès'
  },
  commonError: 'Un problème est survenu. Veuillez réessayer',
  shippingBillingAddress: {
    ...EnUsToasts.shippingBillingAddress,
    errorZipCode: 'Veuillez saisir un code postal valide',
    errorHtmlTag: 'ne doit pas contenir',
    successNextOrder: 'Adresse de livraison pour la prochaine commande modifiée avec succès',
    successSubscription: 'Adresse de livraison pour l’abonnement modifiée avec succès',
    successCheckout: 'Adresse de livraison modifiée avec succès'
  },
  changePaymentMethod: {
    ...EnUsToasts.changePaymentMethod,
    cantRemovePaymentMethod:
      'Impossible de supprimer le mode de paiement : identifiant client incorrect',
    removedPaymentMethod: 'Mode de paiement supprimé et modifié avec succès',
    changedPaymentMethod: 'Mode de paiement modifié avec succès',
    incorrectId: 'Identifiant de commande incorrect'
  },
  orderCreated: 'Commande créée avec succès',
  migrationToV53: {
    title: 'Votre AG1 est mis à niveau !',
    description: "Votre abonnement est désormais sur la version mise à niveau d'AG1."
  }
};
